<template>
    <div class="landing page">

        <div class="pre-anim">
            <div class="elems">
                <span class="lottery-date" style="opacity: 0;">Trekking 10 december</span>

                <svg class="title" width="100%" height="250" viewBox="0 0 600 250" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                        <linearGradient id="b" x1="0%" y1="0%" x2="0%" y2="100%" gradientUnits="userSpaceOnUse" gradientTransform="rotate(-15)">
                            <stop offset="0%" stop-color="#e3bd52"/>
                            <stop offset="100%" stop-color="#9d681b"/>
                        </linearGradient>
                    </defs>

                    <text text-anchor="middle" y="50%" fill="#043168">
                        <tspan x="50%" dy="0em"> Speel het</tspan>
                        <tspan x="50%" dy="1em" >Vakantiespel</tspan>
                    </text>
                </svg>
                <!-- <div class="ticket-wrapper">
                    <img class="ticket" src="static/img/lot.png" />
                </div> -->
                <!-- <img class="prizes" src="/static/img/prijzenpot.png" /> -->
                <v-prizevisual ref="prizeVisual"></v-prizevisual>
            </div>
        </div>

        <span class="lottery-date" style="opacity: 0;">Trekking 10 december</span>
        <div class="plane" >
            <img src="static/img/plane.png"/>
        </div>

        <v-panel>
            <!-- <img class="campaign-visual" src="static/img/campaign-visual.png" /> -->
            <p>Speel het vakantiespel en maak kans op één <strong>heel&nbsp;Staatslot of een Vakantiepakket t.w.v.&nbsp;&euro;&nbsp;404,-!</strong></p>

            <button slot="button" @click="toExplain" class="button stl start-btn" ><span>Start</span></button>
        </v-panel>

    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import screenfull from 'screenfull';
    import { TimelineMax, TweenMax } from '@/vendor';

    import Panel from '@/app/components/Panel';
    import PrizeVisual from '@/app/components/PrizeVisual';

    export default {
        components: {
            'v-panel': Panel,
            'v-prizevisual': PrizeVisual
        },

        computed: {
            isVV()
            {
                return window._rootData.vv === 'true';
            }
        },

        mounted()
        {
            this.$store.dispatch( 'sky', 'light' );
            this.$store.dispatch( 'sun', 'up' );
        },

        methods: {
            toExplain()
            {
                if( this.$helpers.browserCheck().isMobile && screenfull.enabled )
                {
                    screenfull.request();
                }
                this.$router.push({ name: 'Explain' });
            },

            getAnimateIn()
            {
                TweenMax.set( [ '.title', '.ticket', '.lottery-date' ], { rotation: 0.001 });
                /*
                let dropTl = new TimelineMax({ repeat: -1 });
                dropTl.fromTo( '.ticket', 1, { x: '-30%' }, { x: '30%', repeat: 1, yoyo: true, ease: Sine.easeInOut }, 0 );
                dropTl.fromTo( '.ticket', 0.5, { y: '-=30' }, { y: '+=10', repeat: 1, yoyo: true, ease: Sine.easeInOut }, 0 );

                let multiDrop = new TimelineMax({ paused: true });
                multiDrop.add( dropTl );
                */
                let tl = new TimelineMax();

                tl.add( 'switch', 4 );

                tl.from( '.title', 0.7, { opacity: 0, scale: 10, ease: Expo.easeOut }, 0 );

                tl.add( this.$refs.prizeVisual.getTl(), 0.8 );

                // tl.to( multiDrop, 4, { time: 2.5, ease: Sine.easeOut }, 0.3 );
                // tl.from( '.ticket-wrapper', 4, { y: '-50' }, 0.3 );
                // tl.from( '.lottery-date', 0.3, { opacity: 0, y: -40 }, 2 );

                tl.to( '.pre-anim', 0.5, { height: '0px' }, 'switch' );

                tl.from( '.sun', 0.5, { y: -30 }, 'switch+=0.2' );
                tl.from( '.landing.page', 0.75, { backgroundPositionY: '200px', ease: Sine.easeOut }, 'switch' );
                tl.staggerFrom( [ '.campaign-visual', '.landing.page p', '.start-btn' ], 0.5, { y: -20, opacity: 0, ease: Power3.easeOut }, 0.15, 'switch+=0.2' );
                tl.from( '.plane', 10, { x: '-100px', ease: Sine.easeOut }, 'switch' );
                tl.to( '.plane', 7, { y: '20px', repeat: -1, yoyo: true, ease: Sine.easeInOut }, 'switch' );
                tl.to( '.plane', 10, { x: '-20px', repeat: -1, yoyo: true, ease: Sine.easeInOut }, 'switch+=10' );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();
                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Landing.vue